const API_BASE_PATH = process.env.REACT_APP_BASE_URL;
const BASE_URL = `${API_BASE_PATH}/api/v1`;

// ✅ Configurable via env, fallback to 100
export const DEFAULT_PAGE_LIMIT = process.env.REACT_APP_DEFAULT_PAGE_LIMIT
    ? parseInt(process.env.REACT_APP_DEFAULT_PAGE_LIMIT, 10)
    : 100;

// Contracts
export const CONTRACTS_URL = (dataProviderId, limit = DEFAULT_PAGE_LIMIT, offset = 0, search = '') => {
    let url = `${BASE_URL}/contracts?limit=${limit}&offset=${offset}&dataProviderID=${dataProviderId}`;
    if (search.trim()) {
        url += `&search=${encodeURIComponent(search)}`;
    }
    return url;
};

export const ACCOUNTS_URL = (contractId, page = 1, pageSize = 10) => {
    const queryParams = new URLSearchParams({
        page: String(page),
        page_size: String(pageSize),
        contract_id: contractId
        
    });
    return `${BASE_URL}/s3-batch/sources?${queryParams.toString()}`;
};

// Sources
export const SOURCES_URL = (contractId, page = 1, pageSize = 10) => {
    const queryParams = new URLSearchParams({
        page: String(page),
        page_size: String(pageSize),
        contract_id: contractId
    });
    return `${BASE_URL}/s3-batch/sources?${queryParams.toString()}`;
};

export const SOURCE_BY_ID_URL = (sourceId) => `${BASE_URL}/s3-batch/sources/${sourceId}`;
export const CREATE_SOURCE_URL = `${BASE_URL}/s3-batch/sources`;
export const UPDATE_SOURCE_URL = (sourceId) => `${BASE_URL}/s3-batch/sources/${sourceId}`;
export const DELETE_SOURCE_URL = (sourceId) => `${BASE_URL}/s3-batch/sources/${sourceId}`;

// Jobs
export const JOBS_URL = (params = {}) => {
    const queryParams = new URLSearchParams();

    Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
            queryParams.append(key, String(value));
        }
    });

    const queryString = queryParams.toString();
    return `${BASE_URL}/s3-batch/jobs${queryString ? `?${queryString}` : ''}`;
};

export const JOB_BY_ID_URL = (jobId) => `${BASE_URL}/s3-batch/jobs/${jobId}`;
export const CREATE_JOB_URL = `${BASE_URL}/s3-batch/jobs`;
export const RETRY_JOB_URL = (jobId) => `${BASE_URL}/s3-batch/jobs/${jobId}/retry`;
export const CANCEL_JOB_URL = (jobId) => `${BASE_URL}/s3-batch/jobs/${jobId}/cancel`;

// Datasets
export const DATASETS_URL = (contractId, limit = DEFAULT_PAGE_LIMIT, offset = 0, search = '') => {
    let url = `${BASE_URL}/datasets?limit=${limit}&offset=${offset}&contractID=${contractId}`;
    if (search && search.trim()) {
        url += `&search=${encodeURIComponent(search.trim())}`;
    }
    return url;
};

// Dataset by ID
export const DATASET_BY_ID_URL = (datasetId) => `${BASE_URL}/datasets/${datasetId}`;

// Create Dataset
export const CREATE_DATASET_URL = `${BASE_URL}/datasets`;

// Dataset Complete
export const DATASET_COMPLETE_URL = (datasetId) => `${BASE_URL}/datasets/${datasetId}/complete`;

// Dataset Abort
export const DATASET_ABORT_URL = (datasetId) => `${BASE_URL}/datasets/${datasetId}/abort`;

// Dataset files/contents
export const DATASET_CONTENTS_URL = (datasetId, path = '/', limit = DEFAULT_PAGE_LIMIT, offset = 0, search = '') => {
    const url = new URL(`${BASE_URL}/datasets/files/${datasetId}`);
    url.searchParams.append('path', path);
    url.searchParams.append('limit', limit.toString());
    url.searchParams.append('offset', offset.toString());
    if (search) {
        url.searchParams.append('search', search);
    }
    return url.toString();
};

// Uploads
export const UPLOADS_URL = `${BASE_URL}/uploads`;
export const UPLOAD_START_URL = `${BASE_URL}/uploads/start`;
export const UPLOAD_COMPLETE_URL = (uploadId) => `${BASE_URL}/uploads/${uploadId}/complete`;
export const UPLOAD_BATCH_COMPLETE_URL = `${BASE_URL}/uploads/complete`;
export const CONFIG_URL = `${BASE_URL}/uploads/configs`;